import React, { useState, useRef, useEffect } from 'react';
import Dialog from '../../../components/Dialog';
import { Typography } from '@progress/kendo-react-common';
import { Input } from '@progress/kendo-react-inputs';
import { SubmitButton } from '../../../components/form';

interface DeleteLayerModalProps {
  show: boolean;
  handleClose: any;
  defaultValue: string;
  onConfirm: any;
}

const RenameLayerModal: React.FC<DeleteLayerModalProps> = (props: DeleteLayerModalProps) => {
  const [value, setValue] = React.useState('');

  useEffect(() => {
    setValue(props.defaultValue);
  }, [props.defaultValue]);

  return (
    <Dialog
      show={props.show}
      title={<Typography.h3>Delete layer</Typography.h3>}
      onClose={() => {
        props.handleClose();
      }}
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Typography.p >Are you sure you wish to delete Layer</Typography.p>
        <SubmitButton
          type="button"
          label="Submit"
          uppercase={false}
          full={false}
          disabled={false}
          onClick={() => {
            props.onConfirm(value);
          }}
          loading={false}
          className="mt-2 ml-auto"
        />
      </div>
    </Dialog>
  );
};

export default RenameLayerModal;
